/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CmsHomepageBannerFormatEnumType = "BURN_IN" | "CAPTION" | "%future added value";
export type HpRespTopHeroBannerModule_componentModule = {
    readonly messages: {
        readonly items: ReadonlyArray<{
            readonly format: CmsHomepageBannerFormatEnumType | null;
            readonly cmsId: number | null;
            readonly isFullBleedImage: boolean | null;
            readonly imageUrl: string | null;
            readonly linkData: {
                readonly path: string | null;
            };
            readonly " $fragmentRefs": FragmentRefs<"HpRespTopHeroBannerImageItem_bannerItem" | "HpRespSharedHeroBanner_topItem">;
        } | null> | null;
    } | null;
    readonly " $refType": "HpRespTopHeroBannerModule_componentModule";
};
export type HpRespTopHeroBannerModule_componentModule$data = HpRespTopHeroBannerModule_componentModule;
export type HpRespTopHeroBannerModule_componentModule$key = {
    readonly " $data"?: HpRespTopHeroBannerModule_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespTopHeroBannerModule_componentModule">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespTopHeroBannerModule_componentModule",
  "type": "TopHeroBannerModule",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userType",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "messages",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userType",
          "variableName": "userType"
        }
      ],
      "concreteType": "TopHeroBannerMessages",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "items",
          "storageKey": null,
          "args": null,
          "concreteType": "TopHeroBannerItem",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "format",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cmsId",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isFullBleedImage",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "imageUrl",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "linkData",
              "storageKey": null,
              "args": null,
              "concreteType": "LinkData",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "path",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "HpRespTopHeroBannerImageItem_bannerItem",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "HpRespSharedHeroBanner_topItem",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'e60bfa2be4a7a10af1edc37e0f52c994';
export default node;
